import React, { useEffect } from 'react';
import SpinnerSolid from '@/Components/UI/Spinner/SpinnerSolid';
import ProgressBar from '@/Components/Loader/ProgressBar';
import { setIsRequestingRows } from '@/redux/reducers/spreadsheetSlice';
import { useDispatch } from 'react-redux';

const FilterProgressOverlay = ({
  isLiveQuery,
  filterProgressIsRunning,
  progress,
  formatProgressLine,
  totalNumberOfRows,
  currentFile,
}) => {
  if (isLiveQuery || !filterProgressIsRunning) {
    return null;
  }

  const dispatch = useDispatch();

  const totalRows = totalNumberOfRows || currentFile?.metadata?.FileRows || 0;
  const pct = totalRows > 0 && progress ? Math.min((progress.TotalRows / totalRows) * 100, 100) : 0;

  useEffect(() => {
    return () => {
      setTimeout(() => {
        dispatch(setIsRequestingRows(false));
      }, 50);
    };
  }, [dispatch]);

  return (
    <div
      className='
        absolute top-20 left-1/3 transform -translate-x-1/2
        bg-white bg-opacity-95 border-2 border-indigo-600
        rounded-lg shadow-lg flex flex-col px-6 py-3
        z-10 whitespace-nowrap min-w-[30rem]
      '
    >
      <span className='ml-4 text-indigo-600 font-semibold text-sm'>
        <div className='flex items-center'>
          <SpinnerSolid size='small' className='mr-1' />
          {progress ? formatProgressLine(progress) : 'Loading...'}
        </div>
      </span>

      {progress && totalRows > 0 && (
        <div className='mt-2 w-full'>
          <ProgressBar widthPct={pct} />
        </div>
      )}
    </div>
  );
};

export default FilterProgressOverlay;
